import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ToggleInput } from './components/ToggleInput.js';
import { ToggleRoot } from './components/ToggleRoot.js';
import { ToggleThumb } from './components/ToggleThumb.js';
import { ToggleTrack } from './components/ToggleTrack.js';
import { useToggle } from './hooks/useToggle.js';

const Toggle = forwardRef(function Toggle(_a, ref) {
    var { value, onClick, onChange: onChangeInProps, defaultValue = false, disabled = false, color = "default" } = _a, rest = __rest(_a, ["value", "onClick", "onChange", "defaultValue", "disabled", "color"]);
    const { checked, onChange } = useToggle({
        value,
        defaultValue,
        onChange: onChangeInProps,
    });
    return (jsxs(ToggleRoot, { onClick: onClick, children: [jsx(ToggleTrack, { "$checked": checked, "$color": color, "$disabled": disabled }), jsx(ToggleThumb, { "$checked": checked }), jsx(ToggleInput, Object.assign({ "aria-checked": checked, checked: checked, disabled: disabled, ref: ref, role: "switch", type: "checkbox", onChange: onChange }, rest))] }));
});

export { Toggle };
//# sourceMappingURL=Toggle.js.map
